// @flow

// Effect Managers
import { call, select, take } from 'redux-saga/effects'

// Constants
import { SELECT_FARM } from 'hfty-assets/src/constants'
import { FIELD_URL } from 'fc-model-assets'

// Selectors
import { selectedSeasonId$ } from 'hfty-seasons'
import getAssetObject from 'hfty-assets/src/selectors/getAssetObject'

// Controller
import { default as assetsCtrl } from 'fc-ctrl-assets'

export default function *watchFarmSelected (): Generator<*, *, *> {
  while (true) {
    const { payload } = yield take(SELECT_FARM)
    let fieldObject

    if (payload) {
      fieldObject = yield select(getAssetObject(payload))
    }

    if (payload && !fieldObject) {
      const seasonId = yield select(selectedSeasonId$)

      yield call(assetsCtrl.read, {
        url: FIELD_URL,
        queryParams: {
          rootAsset: Number(payload),
          season: seasonId,
          shape: 'true',
        },
      })
    }
  }
}
